import * as React from 'react';
import { useTranslation } from 'hooks';
import { Card, CardContent } from 'components/ui/card';
import { Button } from 'components/ui/ButtonGs';
import { Checkbox } from 'components/ui/checkbox';
import { Label } from 'components/ui/label';
import {
  DeleteTransportRouteDialog,
  DeleteTransportRouteDialogRef,
} from '../../../shared-components/delete-transport-route-dialog/delete-transport-route-dialog';

import { translations } from './translations';
import { TransportRoute } from 'contracts/transport-routes';

type Props = Omit<React.HTMLAttributes<HTMLDivElement>, 'id'> & {
    transportRoute?: TransportRoute;
  onClickSubmit?: () => void;
  onClickCancel?: () => void;
  loading?: boolean;
};

export const UpdateRouteSubmissionBar = ({
  transportRoute,
  onClickSubmit,
  onClickCancel,
  loading,
  ...props
}: Props) => {
  const { getTranslation: t } = useTranslation(translations);
  const [checked, setChecked] = React.useState<boolean | 'indeterminate'>(
    false
  );
  const deleteDialogRef = React.useRef<DeleteTransportRouteDialogRef>(null);

  const handleDeleteClick = React.useCallback(() => {
    deleteDialogRef.current?.openDialog();
  }, []);

  return (
    <>
      <Card {...props}>
        <CardContent className={'pt-6 flex flex-row gap-4'}>
          <div className={'flex flex-row items-center gap-4'}>
            <Checkbox
              id={'contract-agreement'}
              checked={checked}
              onCheckedChange={setChecked}
            />
            <Label
              htmlFor={'contract-agreement'}
              className={'text-gray-500 font-sans'}
            >
              {t('declareInformation')}
            </Label>
          </div>
          <div className={'flex flex-row items-center gap-4 ml-auto'}>
            <Button.Root
              onClick={onClickCancel}
              variant={'secondary'}
              size={'sm'}
              disabled={loading}
            >
              {t('cancelButton')}
            </Button.Root>
            <Button.Root
              onClick={handleDeleteClick}
              variant={'danger'}
              size={'sm'}
              disabled={loading}
            >
              {t('deleteButton')}
            </Button.Root>
            <Button.Root
              onClick={onClickSubmit}
              variant={'primary'}
              size={'sm'}
              disabled={!checked || loading}
            >
              {t('submitButton')}
            </Button.Root>
          </div>
        </CardContent>
      </Card>

      <DeleteTransportRouteDialog ref={deleteDialogRef} id={transportRoute?.id} name={transportRoute?.name} />
    </>
  );
};
